import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type KarteUserDetailedProfileChildFragment = { __typename?: 'DiagnosisChild', age: number, gender: Types.Gender };

export type KarteUserDetailedProfileDiagnosisFragment = { __typename?: 'Diagnosis', annualIncome: number, saving: number, monthlyInsurance: number, investment: number, partner?: { __typename?: 'DiagnosisPartner', birthYear: number, annualIncome: number } | null, children: Array<{ __typename?: 'DiagnosisChild', age: number, gender: Types.Gender }> };

export const KarteUserDetailedProfileChildFragmentDoc = gql`
    fragment KarteUserDetailedProfileChild on DiagnosisChild {
  age
  gender
}
    `;
export const KarteUserDetailedProfileDiagnosisFragmentDoc = gql`
    fragment KarteUserDetailedProfileDiagnosis on Diagnosis {
  partner {
    birthYear
    annualIncome
  }
  annualIncome
  saving
  monthlyInsurance
  investment
  children {
    ...KarteUserDetailedProfileChild
  }
}
    ${KarteUserDetailedProfileChildFragmentDoc}`;